module.exports = __webpack_public_path__ + "media/images/lp_v6_iconbird-c5a6c1d2dbf02535164064cc129d2a1c.webp";